// $249/month Head-to-Toe Unlimited laser hair removal (Tanya · Ottawa).
// One-click booking deep link into the Square-backed booking flow with
// the bookable Square service pre-selected. Short URLs /laser-249, /249
// and /laser-unlimited redirect here (see App.js).
export const LASER_249_SERVICE = "HEAD TO TOE LASER HAIR 6 month promo $249 per month";

export const LASER_249_BOOK_URL = `/book?${new URLSearchParams({
  service: LASER_249_SERVICE,
  provider: "tanya",
  location: "3",
  src: "laser-249",
  note: "Head-to-Toe Unlimited laser hair removal · $249/month × 6 months (all areas)",
}).toString()}`;

export const LASER_249_PLAN_URL = "/crown-reserve-plan?plan=laser-hair-unlimited";

// Oct 29 2026 · Karine — NEW PROMO: any 3 laser hair areas for $99 +tx (Tanya · Ottawa).
export const LASER_ANY3_SERVICE = "PROMO · Laser Hair Removal — Any 3 Areas — $99 +tx";
export const LASER_ANY3_BOOK_URL = `/book?${new URLSearchParams({
  service: LASER_ANY3_SERVICE,
  provider: "tanya",
  location: "3",
  src: "laser-any3-99",
  note: "Any 3 laser hair removal areas · $99 + tax · tell Tanya your 3 areas at check-in",
}).toString()}`;
